import { Box, CircularProgress, Typography } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { WButton } from '@wareclouds/wareclouds-ui';

import {
  CreateAccountPage,
  useGetLeadEvents,
  useOnboardingToken,
} from '../features/onboarding';
import { getOnboardingResumePath } from '@/features/onboarding/utils/onboardingResumePath';
import { isLeadRequestUnauthorized } from '@/libs/axios/leadAxiosInstance';

const OnboardingCreateAccountRoute = () => {
  const { t } = useTranslation(['system', 'button']);
  const { token, clearToken } = useOnboardingToken();
  const hasToken = Boolean(token);

  const eventsQuery = useGetLeadEvents({
    enabled: hasToken,
  });

  if (!hasToken) {
    return <CreateAccountPage />;
  }

  if (eventsQuery.isPending) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="40vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (eventsQuery.isError) {
    if (isLeadRequestUnauthorized(eventsQuery.error)) {
      clearToken();
      return <CreateAccountPage />;
    }

    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap={2}
        minHeight="40vh"
        px={2}
      >
        <Typography align="center" color="text.secondary">
          {t('GENERAL_ERROR', { ns: 'system' })}
        </Typography>
        <WButton
          label={t('retry', { ns: 'button' })}
          variant="contained"
          color="primary"
          onClick={() => eventsQuery.refetch()}
        />
      </Box>
    );
  }

  const resumePath = getOnboardingResumePath(eventsQuery.data ?? []);
  return <Navigate to={resumePath} replace />;
};

export default OnboardingCreateAccountRoute;
